import React from 'react';
import { LoadingBar } from '../layout';
// FUNCTIONS
export default function Page({ children, ...props }) {
    return (<div {...props}>
            <LoadingBar />
            {children}
        </div>);
}
